// 관리자 정보 객체
const defaultMenuDgstfnParams = {
  menuId: '',
  rspns5: 'N',
  rspns4: 'N',
  rspns3: 'N',
  rspns2: 'N',
  rspns1: 'N',
  opnn: '',
};

export { defaultMenuDgstfnParams };